import React from "react";
import FormInput from "./FormInput";

/******************************************************
 *
 * Champ Téléphone
 *
 ******************************************************/

export default function PhoneField({

    label = "Téléphone",

    icon = "bi bi-telephone",

    name = "phoneNumber",

    value = "",

    onChange,

    onBlur,

    error = "",

    required = false,

    disabled = false,

    readOnly = false,

    autoFocus = false,

    placeholder = "0550123456",

    col = "col-12",

    labelCol = 4,

    inputCol = 8,

    className = ""

}) {

    //--------------------------------------------------
    // Autorise uniquement les chiffres
    //--------------------------------------------------

    const handleChange = (event) => {

        let value = event.target.value;

        // Supprime tous les caractères non numériques

        value = value.replace(/\D/g, "");

        // Maximum 10 chiffres

        if (value.length > 10) {

            value = value.substring(0, 10);

        }

        if (onChange) {

            onChange({

                ...event,

                target: {

                    ...event.target,

                    name,

                    value

                }

            });

        }

    };

    //--------------------------------------------------

    return (

        <FormInput

            type="tel"

            label={label}

            icon={icon}

            name={name}

            value={value}

            onChange={handleChange}

            onBlur={onBlur}

            error={error}

            required={required}

            disabled={disabled}

            readOnly={readOnly}

            autoFocus={autoFocus}

            placeholder={placeholder}

            autoComplete="tel"

            maxLength={10}

            col={col}

            labelCol={labelCol}

            inputCol={inputCol}

            className={className}

        />

    );

}